import { Link } from "wouter";

export function SeoPageFooter() {
  return (
    <footer className="border-t border-border/40 py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-8 text-sm">
          <div>
            <p className="font-semibold text-foreground mb-3">Product</p>
            <ul className="space-y-2">
              <li><Link href="/auto-quote" className="text-muted-foreground hover:text-foreground transition-colors">Auto Quote</Link></li>
              <li><Link href="/ai-quoting-software" className="text-muted-foreground hover:text-foreground transition-colors">AI Quoting App</Link></li>
              <li><Link href="/estimating-software-for-builders" className="text-muted-foreground hover:text-foreground transition-colors">Estimating Software</Link></li>
              <li><Link href="/quoting-app-for-builders" className="text-muted-foreground hover:text-foreground transition-colors">Mobile App</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-foreground mb-3">Trades</p>
            <ul className="space-y-2">
              <li><Link href="/tradesman-quoting-tool" className="text-muted-foreground hover:text-foreground transition-colors">For Tradesmen</Link></li>
              <li><Link href="/quoting-software-for-electricians" className="text-muted-foreground hover:text-foreground transition-colors">For Electricians</Link></li>
              <li><Link href="/quoting-software-for-plumbers" className="text-muted-foreground hover:text-foreground transition-colors">For Plumbers</Link></li>
              <li><Link href="/quoting-software-for-roofers" className="text-muted-foreground hover:text-foreground transition-colors">For Roofers</Link></li>
              <li><Link href="/quoting-software-for-plasterers" className="text-muted-foreground hover:text-foreground transition-colors">For Plasterers</Link></li>
              <li><Link href="/quoting-software-for-decorators" className="text-muted-foreground hover:text-foreground transition-colors">For Decorators</Link></li>
              <li><Link href="/quoting-software-for-contractors" className="text-muted-foreground hover:text-foreground transition-colors">For Contractors</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-foreground mb-3">Resources</p>
            <ul className="space-y-2">
              <li><Link href="/blog" className="text-muted-foreground hover:text-foreground transition-colors">Blog &amp; Guides</Link></li>
              <li><Link href="/glossary" className="text-muted-foreground hover:text-foreground transition-colors">Glossary</Link></li>
              <li><Link href="/comparisons" className="text-muted-foreground hover:text-foreground transition-colors">Compare</Link></li>
              <li><Link href="/uk-builder-quoting-survey-2026" className="text-muted-foreground hover:text-foreground transition-colors">Research &amp; Data</Link></li>
              <li><Link href="/about" className="text-muted-foreground hover:text-foreground transition-colors">About</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold text-foreground mb-3">Legal</p>
            <ul className="space-y-2">
              <li><Link href="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy</Link></li>
              <li><Link href="/terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border/40 pt-6 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} The Proper Tool. Built for builders.</p>
        </div>
      </div>
    </footer>
  );
}
